import "./ColourPickerComponent.scss";
import {ColourPickerService} from "../service/ColourPickerService";

export const ColourPickerComponent = "tfColourPicker";

export function tfColourPicker() {
    return {
        templateUrl: "app/components/colour-picker/component/ColourPickerComponent.html",
        bindings: {
            name: "<",
            value: "<",
            placeholder: "<",
            required: "<",
            defaultColour: "<",
            onChange: "&"
        },
        controller: ColourPickerComponentController,
        controllerAs: "ctrl"
    };
}

export class ColourPickerComponentController {

    public name: string;
    public value: string;
    public placeholder: string;
    public required?: boolean;
    public defaultColour?: string;

    public onChange: Function;
    private service: ColourPickerService;

    /** @ngInject */
    public constructor(colourPickerService: ColourPickerService) {
        this.service = colourPickerService;
    }

    public openPicker() {
        const current = this.value;
        const data = {selectedColour: current, defaultColour: this.defaultColour };

        this.service.open(data)
            .filter((value) => value != null)
            .subscribe((value) => {
                this.value = value!;
                this.onChange({ colour: value });
            });
    }
}
